// extracted by mini-css-extract-plugin
module.exports = {"box":"LoginPage_box__3SfIs","title":"LoginPage_title__3mGgL","button":"LoginPage_button__3x_vQ","link":"LoginPage_link__BHBA3"};